import React from 'react';
import { Link } from 'react-router-dom';
interface CardProps {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  link?: {
    text: string;
    url: string;
  };
  className?: string;
}
const Card = ({
  title,
  icon,
  children,
  link,
  className = ''
}: CardProps) => {
  return <div className={`bg-surface p-6 rounded-lg shadow-card border border-gray-100 transition-all duration-300 hover:shadow-card-hover hover:border-primary/20 ${className}`} data-id="element-116">
      {icon && <div className="mb-4 text-primary" data-id="element-117">{icon}</div>}
      <h3 className="text-text-primary font-raleway font-semibold mb-3" data-id="element-118">
        {title}
      </h3>
      <div className="text-text-secondary font-open-sans mb-4" data-id="element-119">{children}</div>
      {link && <Link to={link.url} className="text-primary font-medium hover:underline inline-flex items-center" data-id="element-120">
          {link.text}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1 transition-transform duration-200 group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-121">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-122" />
          </svg>
        </Link>}
    </div>;
};
export default Card;